import { render, staticRenderFns } from "./InstructorCreate.vue?vue&type=template&id=6f2a1d8e&"
import script from "./InstructorCreate.vue?vue&type=script&lang=js&"
export * from "./InstructorCreate.vue?vue&type=script&lang=js&"
import style0 from "./InstructorCreate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports